import React from 'react'

const NumericGauge = ({counter, value}) => (
  <div>
    <div>{counter.name}</div>
    <div>{value || counter.defaultValue}</div>
  </div>
)

const TotalGauge = ({counter, value}) => (
  <div>
    <div>{counter.name}</div>
    <div>{value || counter.defaultValue} / {counter.max}</div>
  </div>
)

const PercentGauge = ({counter, value}) => (
  <div>
    <div>{counter.name}</div>
    <div>{`${(((value -counter.min) / (counter.max - counter.min)) * 100)}%`}</div>
  </div>
)
  
const BarGauge = ({counter, value, color}) => (
  <div>
    <div>{counter.name}</div>
    <div style={{ width: 100, display: 'block', borderRadius: '.5em', height: '1em', border: `2px ${color} solid`, overflow: 'hidden' }}>
      <div style={{ width: `${(((value -counter.min) / (counter.max - counter.min)) * 100)}%`, display: 'block', height: '1em', background: color }}></div>
    </div>
  </div>
)


export const CounterGauge = ({styles, ...props}) => {
  const { gauge, ...counterProps } = props
  switch (gauge.kind) {
    case 'bar': return <BarGauge {...counterProps} color={styles.assetsFill} />
    case 'percent': return <PercentGauge {...counterProps} />
    case 'total': return <TotalGauge {...counterProps} />
    default: return <NumericGauge {...counterProps} />
  }
}